import useZohoMcpUnlocker from '../Components/ZohoId/useZohoMcpUnlocker'
import { useDispatch, useSelector } from 'react-redux'
import { selectContactConfig, selectCurrentContractActive } from './SubscriptionFormSelectors'
import { addContractErrors, removeErrorFromContract } from './SubscriptionFormSlice'
import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useFormStatus = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { errors, config } = useSelector(selectCurrentContractActive)
  const { country } = useSelector(selectAuthData)
  const upperCaseCountry = country.toUpperCase()
  const {
    isEditable = true,
    resendAllowed = true,
    contractLastSaveValidate: lastSentDate = null,
  } = config || {}
  const contract = useSelector(selectCurrentContractActive)
  const { contractLoaded, isValidZohoId } = useSelector(selectContactConfig)
  const { blockedForAgent } = useZohoMcpUnlocker()
  const addErrorToContract = (id, field) => {
    dispatch(addContractErrors({ data: field, id }))
  }
  const removeContractError = (id, field) => {
    dispatch(removeErrorFromContract({ data: field, id }))
  }

  const testFieldValidity = (field, value, validations, contractId) => {
    if (!validations || !validations[field]) {
      return
    }

    const rule = validations[field]
    const countriesUsingV1Rule = ['FR']
    const isValid = countriesUsingV1Rule.includes(upperCaseCountry)
      ? rule(contract, false, value)
      : rule.validate(contract, false, value)

    if (!isValid) {
      addErrorToContract(contractId, {
        [field]:
          t(`subscriptionForm:validation_errors_v2.${field}`) ??
          `Field ${field} is missing in validation list translations`,
      })
    } else {
      removeContractError(contractId, field)
    }
  }

  return {
    formIsLoaded: contractLoaded === true,
    isEditable,
    lastSentDate,
    errors,
    zohoIsInValid: !isValidZohoId || blockedForAgent,
    resendAllowed,
    addErrorToContract,
    testFieldValidity,
    removeContractError,
  }
}

export default useFormStatus
